export default function dateid(date = new Date()) {
  const prefix = date.toISOString().replace(/[^0-9]/g, '');
  const suffix = Math.floor(Math.random() * 90000) + 10000;
  return `${prefix}${suffix}`;
}
